<template>
  <header class="header-component">
    <dx-toolbar class="header-toolbar">
      <dx-item :visible="menuToggleEnabled" location="before" css-class="menu-button">
        <template #default>
          <dx-button icon="menu" styling-mode="text" @click="toggleMenuFunc"/>
        </template>
      </dx-item>

      <dx-item v-if="title" location="before" css-class="header-title dx-toolbar-label">
        <template>
          <div>{{ title }}</div>
        </template>
      </dx-item>

<!--      <dx-item  location="after" >-->
<!--        <template  #default>-->
<!--          <div>  服务器公网IP: <el-link type="primary">{{ip}}</el-link></div>-->

<!--        </template>-->
<!--      </dx-item>-->

      <dx-item  location="after" >
         <template #default>
                <dx-button icon="cart" type="default" text="充值" styling-mode="contained" @click="recharge=true"/>
         </template>
      </dx-item>

        <dx-item  location="after" >
            <template #default>
                <div style="width: 100px" align="center">
                    <span>余额：{{pointNumber}}</span>
                </div>
            </template>
        </dx-item>

      <dx-item location="after" locate-in-menu="auto" menu-item-template="menuUserItem">
        <template #default>
          <div>
            <dx-button class="user-button authorization" :width="150" height="100%" styling-mode="outlined" >
              <user-panel :user="user" :menu-items="userMenuItems" menu-mode="context" />
            </dx-button>
          </div>
        </template>
      </dx-item>
<!--      <template #menuUserItem>-->
<!--        <user-panel :user="user" :menu-items="userMenuItems" menu-mode="list"/>-->
<!--      </template>-->
    </dx-toolbar>

    <DxPopup :width="660" :height="540" :show-title="true" :drag-enabled="false"  :visible="recharge" title="充值" @hidden="handleHidden">
      <RechargeMain @close="recharge=false" @renew="getTime"></RechargeMain>
    </DxPopup>

  </header>
</template>

<script>
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import auth from "../auth";
import RechargeMain from "@/views/recharge/RechargeMain.vue";
import UserPanel from "./user-panel";
import {getUserPoint} from "@/request/http";

export default {
  props: {
    menuToggleEnabled: Boolean,
    title: String,
    toggleMenuFunc: Function,
    logOutFunc: Function
  },
  created() {
    auth.getUser().then((e) => this.user = e.data);
      this.$http.getUserPoint({uid: '0', type:1}).then(res => {
          this.pointNumber=res.data.point
      })
  },
  data() {
    return {
      ip:'',
      user: { },
        pointNumber:0,
      userMenuItems: [
        {
          text: "修改密码",
          icon: "edit",
          onClick: this.toUpdatePassword
        },
        {
          text: "退出系统",
          icon: "runner",
          onClick: this.onLogoutClick
        }
      ],
      recharge: false,
      times: null,   //倒计时250s，可以任意设定数字
    };
  },
  methods: {
    onLogoutClick() {
      auth.logOut();
      this.$websocket.close();
      this.$router.push({
        path: "/login-form",
        query: { redirect: this.$route.path }
      });
    },
    toUpdatePassword() {
      this.$router.push({
        path: "/change-password",
        query: { redirect: this.$route.path }
      });
    },
    getTime() {//定时刷新前端用户信息
      this.times=300
      this.timer = setInterval(()=>{
        this.times--
        this.$http.getUserPoint({'uid': '0', 'type':1}).then(res=>{
          if(res.data.point!== this.pointNumber){
            this.pointNumber=res.data.pointNumber
            this.$message({type: 'success', message: '您的充值已到账', center: true, offset: window.screen.height / 2});
            clearInterval(this.timer)
            this.times=300
          }
        })
        if(this.times===0){
          clearInterval(this.timer)
        }
      },1000)
    },
    handleHidden(){
      if(this.timer != null) {
        clearInterval(this.timer)
      }
    }
  },
  components: {
    DxToolbar,
    DxItem,
    UserPanel,
    RechargeMain,
  }
};
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
@import "../dx-styles.scss";

.header-component {
  flex: 0 0 auto;
  z-index: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  .dx-toolbar .dx-toolbar-item.menu-button > .dx-toolbar-item-content .dx-icon {
    color: $base-accent;
  }
}

.dx-toolbar.header-toolbar .dx-toolbar-items-container .dx-toolbar-after {
  padding: 0 40px;

  .screen-x-small & {
    padding: 0 20px;
  }
}

.dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
  width: $side-panel-min-width;
  text-align: center;
  padding: 0;
}

.header-title .dx-item-content {
  padding: 0;
  margin: 0;
}

.dx-theme-generic {
  .dx-toolbar {
    padding: 10px 0;
  }

  .user-button > .dx-button-content {
    padding: 3px;
  }
}
</style>
